import {closeModal, openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {EmbeddedEditorConsentModalProps} from '@Modals/embedded-editor-consent-modal/embedded-editor-consent-modal';

export const openEmbeddedEditorConsentModal = (props: EmbeddedEditorConsentModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.EMBEDDED_EDITOR_CONSENT_MODAL,
      panelProps: props,
    })
  );
};

export const closeEmbeddedEditorConsentModal = (): void => {
  window.PMW.redux.store.dispatch(closeModal(MODALS_IDS.EMBEDDED_EDITOR_CONSENT_MODAL));
};
